/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unresolved */
import mercatelyIcon from "images/integrations/mercately.png";
import { getShopLink } from './getShopLink';

export const addMercatelyPaymentMethod = (methods, order) => ([
  ...methods,
  {
    name: 'Mercately',
    key: 'mercately',
    icon: mercatelyIcon,
    selected: true,
    link: getShopLink(order)
  }
]);
